import {$, datetime, Schema} from 'simpli-web-sdk'
import DeliverySatisfactionSurveyHistoryResponse from '@/model/response/DeliverySatisfactionSurveyHistoryResponse'
import RenderStar from '@/components/render/RenderStar.vue'
import RenderImage from '@/components/render/RenderImage.vue'

export default (model: DeliverySatisfactionSurveyHistoryResponse): Schema => ({
  documento: {
    content: model.carga && model.carga.nroNotaFiscal,
  },
  danfe: {
    content: model.carga && model.carga.danfe,
  },
  xpedido: {
    content: model.carga && model.carga.xpedido,
  },
  nomeRecebedor: {
    content: model.carga && model.carga.nomeRecebedor,
  },
  documentoRecebedor: {
    content: model.carga && model.carga.documentoRecebedor,
  },
  razaoSocial: {
    content: model.carga && model.carga.transportador && model.carga.transportador.responsavel.razaoSocial,
  },
  nomeMotorista: {
    content: model.carga && model.carga.nomeMotorista,
  },
  cpfMotorista: {
    content: model.carga && model.carga.cpfMotorista,
  },
  pergunta1: {
    content: model.pergunta1,
  },
  notaPergunta1: {
    content: {
      component: RenderStar,
      props: {
        label: model.translateColumn('notaPergunta1'),
        value: model.notaPergunta1,
      },
    },
    textContent: null,
  },
  notaPergunta1Alt: {
    textContent: model.notaPergunta1 || (model.notaPergunta1 === null ? '-' : '0'),
  },
  pergunta2: {
    content: model.pergunta2,
  },
  notaPergunta2: {
    content: {
      component: RenderStar,
      props: {
        label: model.translateColumn('notaPergunta2'),
        value: model.notaPergunta2 || (model.notaPergunta2 === null ? '-' : '0'),
      },
    },
    textContent: null,
  },

  notaPergunta2Alt: {
    textContent: model.notaPergunta2 || (model.notaPergunta2 === null ? '-' : '0'),
  },

  imgUrl: {
    content: {
      component: RenderImage,
      props: {
        src: model.imgUrl,
        alt: 'Photo',
      },
    },
    textContent: null,
  },

  imgUrlAlt: {
    textContent: model.imgUrl || '',
  },

  data: {
    content: datetime(model.data),
  },
})
